export const CONSENTIMIENTOS = [
  { value: "PROTESIS_REMOVIBLE", label: "Consentimiento prótesis removible" },
  { value: "PROTESIS_FIJA", label: "Consentimiento prótesis fija" },
  { value: "PERIODONCIA", label: "Consentimiento periodoncia" },
  { value: "ORTODONCIA", label: "Consentimiento ortodoncia" },
  { value: "ODONTOPEDIATRIA", label: "Consentimiento odontopediatría" },
  { value: "OBTURACION", label: "Consentimiento obturación" },
  { value: "EXTRACCION", label: "Consentimiento extracción" },
  { value: "BLANQUEAMIENTO", label: "Consentimiento blanqueamiento" },
  { value: "ENDODONCIA", label: "Consentimiento endodoncia" },
  { value: "IMPLANTE", label: "Consentimiento implante" },
  { value: "CONSENTIMIENTO_PROTECCION_DATOS", label: "Protección de datos"}
];

